import React, { useMemo } from "react";
import { Card, Table } from "react-bootstrap";
import ContentLoader from "react-content-loader";
import { AFPlansTableHeadings, FilingTableHeadings, UserTableHeadings } from "../TableHeaders";

type Props = {
  portalModule: string;
};

const TableLoader: React.FC<Props> = (props: Props) => {
  const { portalModule } = props;

  const currentTable = useMemo(() => {
    let currentModule: any[] = [];
    switch (portalModule) {
      case "user":
        currentModule = UserTableHeadings;
        break;
      case "taxExpert":
        currentModule = UserTableHeadings;
        break;
      case "AFPlan":
        currentModule = AFPlansTableHeadings;
        break;
      case "filing":
        currentModule = FilingTableHeadings;
        break;
    }
    return currentModule;
  }, [portalModule]);

  return (
    <Card className="table-card">
      <Card.Body>
        <Table responsive>
          <thead>
            <tr>
              {currentTable.map((_heading, index) => (
                <th className={`${_heading.classPrefix}${_heading.size}`} key={`user-th-${index}`}>
                  {_heading.title}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array(10)
              .fill("_", 0)
              .map((item, index) => (
                <tr key={`table-tr-${index}`}>
                  {currentTable.map((_heading, index) => (
                    <td key={`table-td-${index}`}>
                      <ContentLoader
                        viewBox={`0 0 ${_heading.size === 50 ? 12 : _heading.size} 12`}
                      >
                        <rect
                          x="0"
                          y="0"
                          rx="0"
                          ry="0"
                          width={_heading.size === 50 ? 10 : _heading.size}
                          height="10"
                        />
                      </ContentLoader>
                    </td>
                  ))}
                </tr>
              ))}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};

export default TableLoader;
